import shortid from 'shortid'

const SHORT_ID_CHARS =
  '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_~'
export function createShortId() {
  shortid.characters(SHORT_ID_CHARS)
  return shortid.generate()
}

export function normalize(src) {
  return src
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // source: https://stackoverflow.com/a/37511463
    .toLowerCase()
    .replace(/\s/g, '')
}
